import MoBill from '@assets/animations/MoBill.json';
import MoCards from '@assets/animations/MoCards.json';

export const SPLITS_LOTTIES = {
  MO_BILL: MoBill,
  MO_CARDS: MoCards,
};

export const SPLITS_VIEW_STEP = {
  LANDING: 'landing',
  SELECT_MEMBER: 'selectMember',
  PHONE_INPUT: 'phoneInput',
  OTP: 'otp',
} as const;

export type SplitsViewStep =
  (typeof SPLITS_VIEW_STEP)[keyof typeof SPLITS_VIEW_STEP];

export const SPLITS_UTM = {
  INTRO: {
    SOURCE: 'splits',
    MEDIUM: 'webapp',
    CAMPAIGN: 'splits_payment_funnel',
    CONTENT: 'split_intro',
  },
  BREAKDOWN: {
    SOURCE: 'splits',
    MEDIUM: 'webapp',
    CAMPAIGN: 'splits_payment_funnel',
    CONTENT: 'split_breakdown',
  },
  COMPLETED: {
    SOURCE: 'splits',
    MEDIUM: 'webapp',
    CAMPAIGN: 'splits_payment_funnel',
    CONTENT: 'split_completed',
  },
};

export const SPLITS_PAGES = {
  LANDING: 'landing',
  CONFIRMATION: 'confirmation',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export const SPLITS_QUERY_PARAMS = {
  SPLIT_ID: 'splitId',
  PARTICIPANT_ID: 'participantId',
  PAYER_METADATA: 'payerMetadata',
  IS_VERIFIED_NUMBER: 'isVerifiedNumber',
  ALREADY_PAID: 'already_paid',
  REFERRAL_CODE: 'referralCode',
  IN_APP: 'in_app',
  EMBEDDED: 'embedded',
} as const;

export const SPLITS_ROUTES = {
  CONFIRMATION: '/splits/confirmation',
  SUCCESS: '/splits/success',
  ERROR: '/splits/error',
} as const;

export const SPLIT_REFERRAL_CODE = 'MOSPLIT';

export const OTP_LENGTH = 6;
export const RESEND_COUNTDOWN_SECONDS = 59;
